// src/components/operationCenter/widgets/token/overview/TwSupplyUnlocksWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import SupplyUnlocksCard from "@/components/tokenPage/overview/SupplyUnlocksCard";

const TwSupplyUnlocksWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  // tokenId is required for supply unlock data; fall back to ticker lowercase
  const tokenId = config.tokenId || config.ticker.toLowerCase();
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} tokenId={tokenId} providers={[]}>
        {tokenId && <SupplyUnlocksCard tokenId={tokenId} />}
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwSupplyUnlocksWidget;
